import React from 'react';

import { CookiesProvider, Cookies } from 'react-cookie';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';
import { logoutUserRequest } from '../redux/reducers/login';
import { setReturnItem } from '../redux/reducers/view';
import { xapiRequest } from '../redux/reducers/xapi';



const cookies = new Cookies();

const authHOC = WrappedComponent => {
  class HOC extends React.Component {

    getParameterByName(name) {
      var queryStringFromStartOfValue = window.location.search.split(name + '=')[1];
      return queryStringFromStartOfValue !== undefined ? queryStringFromStartOfValue.split('&')[0] : null;
      }
    componentWillMount() {
     
      const { history, loginReducer, getToken, authUser,authAdmin, match, loginAdminRequest } = this.props;
      const isUserLoggedIn = loginReducer.isLoggedIn;
      //?loginAs=1&userId=1008&firstName=Shaun&lastName=Stapleton&email=staging2ff@codal.co.za&avatar=&biography=&lastLogin=2021-01-14%2012:11:31&numberOfUnreadMessages=0&isTeamLeader=&isTour=1&isComplete=0&dateCreated=2021-01-14%2012:11:30
      if (!isUserLoggedIn && this.getParameterByName('loginAs') == null) {
        history.replace('/');
      }else if(this.getParameterByName('loginAs') != null){
        try {
          
       
          loginAdminRequest({userId:this.getParameterByName('userId'), firstName:this.getParameterByName('firstName'), lastName:this.getParameterByName('lastName'),email:this.getParameterByName('email'), avatar:this.getParameterByName('avatar'), numberOfUnreadMessages:this.getParameterByName('numberOfUnreadMessages')})
         
        } catch (error) {
          
        }
      
      }
    
      if (isUserLoggedIn && (!loginReducer.token && !loginReducer.user && this.getParameterByName('loginAs') == null)) {
      
        getToken(cookies.get('token'));
        authUser();
      }else if (isUserLoggedIn && (!loginReducer.token && !loginReducer.user && this.getParameterByName('loginAs') != null)){
        
        getToken(cookies.get('token'));
        authAdmin({userId:this.getParameterByName('userId'), firstName:this.getParameterByName('firstName'), lastName:this.getParameterByName('lastName'),email:this.getParameterByName('email'), avatar:this.getParameterByName('avatar'), numberOfUnreadMessages:this.getParameterByName('numberOfUnreadMessages')});
      }else{
        console.log('no token')
        logoutUserRequest(loginReducer.token)
      }
    }

    componentWillReceiveProps(nextProps) {
      const { history, loginReducer, match, getToken } = nextProps;
      const isUserLoggedIn = loginReducer.isLoggedIn;
     
      if (isUserLoggedIn && loginReducer.token !== null && cookies.get('token') === undefined) {
        cookies.set('token', loginReducer.token);
      }
      try {
        if (match.path !== '/' && !isUserLoggedIn) {
          xapiRequest('Logged Out')
          cookies.remove('token');
          history.replace('/');
          window.location.reload();
        }
      } catch (error) {
        
      }
     
      if (isUserLoggedIn && !loginReducer.token) {
        getToken(cookies.get('token'));
       
      }
      if(loginReducer.user && nextProps.userProgramsFull  && nextProps.userProgramsFull.fetching===false && nextProps.userProgramsFull.isFetched===false){
        xapiRequest('Returned')
        nextProps.getUserProgramsFullRequest()
        nextProps.dropdownsRequest()
      }
      
      if(loginReducer.user && nextProps.getModulesForProgram  && nextProps.userProgramsFull  && nextProps.userProgramsFull.fetching===false && nextProps.userProgramsFull.isFetched===false){
        console.log('cookie return',cookies );
        xapiRequest('Returned')
        nextProps.getModulesForProgram()
      }
     
      if(loginReducer.user && nextProps.content && nextProps.content.length==0 && nextProps.getContentForModule && nextProps.userProgramsFull.selectedModuleId  && nextProps.contentReducer.fetching===false && nextProps.userProgramsFull.isFetched===true){
        xapiRequest('Returned')
        nextProps.getContentForModule()
      }
      
    }

    testin124 = ()=>{
      console.log('my test')
    }

    render() {
      return (
      
          <WrappedComponent {...this.props} />
       
      );
    }
  }

  return HOC;
};

export default authHOC;
